import { Plus, Trash2 } from "lucide-react";
import { ImageField, Panel, TextField } from "./fields";

const Remove = ({ onClick, testid }) => (
  <button type="button" onClick={onClick} className="text-ink/40 hover:text-red-600" title="Remove" data-testid={testid}><Trash2 className="h-4 w-4" /></button>
);
const Add = ({ onClick, testid, children }) => (
  <button type="button" onClick={onClick} className="btn-outline !py-2" data-testid={testid}><Plus className="h-4 w-4" />{children}</button>
);

const patchAt = (list, i, p) => list.map((x, k) => (k === i ? { ...x, ...p } : x));

export const ContentTab = ({ slides, news, setSlides, setNews }) => (
  <div className="space-y-6" data-testid="admin-content-tab">
    <Panel title="Home page slideshow" hint="Large photos at the top of the home page."
      action={<Add testid="add-slide" onClick={() => setSlides([...slides, { image: "", caption: "", subtitle: "" }])}>Add slide</Add>}>
      <div className="space-y-5">
        {slides.map((s, i) => (
          <div key={i} className="grid gap-4 rounded-xl border border-ink/10 p-4 md:grid-cols-[1fr_1fr_auto]" data-testid={`slide-${i}`}>
            <div className="md:col-span-2"><ImageField label={`Slide ${i + 1} photo`} value={s.image} onChange={(v) => setSlides(patchAt(slides, i, { image: v }))} testid={`slide-${i}-image`} /></div>
            <div className="flex justify-end"><Remove onClick={() => setSlides(slides.filter((_, k) => k !== i))} testid={`slide-${i}-remove`} /></div>
            <TextField label="Headline" value={s.caption} onChange={(v) => setSlides(patchAt(slides, i, { caption: v }))} testid={`slide-${i}-caption`} />
            <TextField label="Small line above" value={s.subtitle} onChange={(v) => setSlides(patchAt(slides, i, { subtitle: v }))} testid={`slide-${i}-subtitle`} />
          </div>
        ))}
      </div>
    </Panel>
    <Panel title="Specials & news" hint="Cards below the search panel."
      action={<Add testid="add-news" onClick={() => setNews([...news, { id: crypto.randomUUID().slice(0, 8), title: "", badge: "", image: "", description: "" }])}>Add card</Add>}>
      <div className="space-y-5">
        {news.map((n, i) => (
          <div key={n.id} className="grid gap-4 rounded-xl border border-ink/10 p-4 md:grid-cols-2" data-testid={`news-${i}`}>
            <div className="flex items-start justify-between md:col-span-2">
              <ImageField label="Photo" value={n.image} onChange={(v) => setNews(patchAt(news, i, { image: v }))} testid={`news-${i}-image`} />
              <Remove onClick={() => setNews(news.filter((_, k) => k !== i))} testid={`news-${i}-remove`} />
            </div>
            <TextField label="Title" value={n.title} onChange={(v) => setNews(patchAt(news, i, { title: v }))} testid={`news-${i}-title`} />
            <TextField label="Badge" value={n.badge} onChange={(v) => setNews(patchAt(news, i, { badge: v }))} testid={`news-${i}-badge`} />
            <div className="md:col-span-2"><TextField multiline label="Description" value={n.description} onChange={(v) => setNews(patchAt(news, i, { description: v }))} testid={`news-${i}-description`} /></div>
          </div>
        ))}
      </div>
    </Panel>
  </div>
);
